import { render } from "./FramedCard.vue?vue&type=template&id=c0957af8&scoped=true"
import script from "./FramedCard.vue?vue&type=script&lang=js"
export * from "./FramedCard.vue?vue&type=script&lang=js"

import "./FramedCard.vue?vue&type=style&index=0&id=c0957af8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0957af8"]])

export default __exports__